import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-root',
  template: `
      <div [ngClass]="{'bg-color-dark-color-white':backgroundColorDark}">
          <app-navbar></app-navbar>
          <div class="container">
              <router-outlet></router-outlet>
          </div>
          <app-footer></app-footer>
      </div>
  `,
  styles: []
})
export class AppComponent implements OnInit {
  backgroundColorDark: boolean = false;

  ngOnInit() {
    if(this.getCookie("theme") == "DARK") {
      this.backgroundColorDark = true;
    }
    else
    if(this.getCookie("theme") == "WHITE") {
      this.backgroundColorDark = false;
    }
  }

  getCookie (cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
}
